import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DeviceDetectorModule } from 'ngx-device-detector';

/* tslint:disable */

import { EuiAppComponent, EuiAppPageWrapperDirective, EuiAppToolbarDirective } from './eui-app.component';

import { EuiAppHeaderModule } from './eui-app-header/header.module';
import { EuiAppFooterModule } from './eui-app-footer/footer.module';
import { EuiAppToolbarModule } from './eui-app-toolbar/toolbar.module';
import { EuiAppTopMessageModule } from './eui-app-top-message/top-message.module';
import { EuiAppSidebarModule } from './eui-app-sidebar/sidebar.module';
import { EuiUserProfileModule } from '../eui-user-profile/user-profile.module';
import { EuiSearchModule } from '../eui-search/search.module';
import { EuiBreadcrumbModule } from '../eui-breadcrumb/breadcrumb.module';
import { EuiLanguageSelectorModule } from '../eui-language-selector/language-selector.module';
import { EuiSidebarToggleModule } from '../eui-sidebar-toggle/sidebar-toggle.module';
import { EuiBlockDocumentComponentModule } from '../../components/eui-block-document/eui-block-document.module';
import { EuiGrowlComponentModule } from '../../components/eui-growl/eui-growl.module';
import { EuiDimmerModule } from '../../layout/eui-dimmer/dimmer.module';
import { EuiToolbarModule } from '../eui-toolbar';

/* tslint:enable */

const MODULES = [
    EuiUserProfileModule,
    EuiSearchModule,
    EuiBreadcrumbModule,
    EuiLanguageSelectorModule,
    EuiSidebarToggleModule,

    EuiAppHeaderModule,
    EuiAppFooterModule,
    EuiAppToolbarModule,
    EuiToolbarModule,
    EuiAppSidebarModule,
    EuiAppTopMessageModule,

    EuiBlockDocumentComponentModule,
    EuiGrowlComponentModule,
    EuiDimmerModule,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        DeviceDetectorModule.forRoot(),
        ...MODULES,
    ],
    declarations: [
        EuiAppComponent,
        EuiAppPageWrapperDirective,
        EuiAppToolbarDirective,
    ],
    exports: [
        EuiAppComponent,
        EuiAppPageWrapperDirective,
        EuiAppToolbarDirective,
        ...MODULES,
    ],
})
export class EuiAppModule { }
